import React from 'react';

import { ILottieAnimationProps, LottieAnimation } from 'components/animation';

import animation from './json/index.json';

export const FavoriteLoading: React.FC<Omit<ILottieAnimationProps, 'options'>> = ({ ...props }) => {
  return <LottieAnimation {...props} options={{ animationData: animation, loop: true }} />;
};
